module.exports = __webpack_public_path__ + "assets/dropdown-icon-31a79d097612d25fbab90ab151c936ce.png";